import { gsap } from 'gsap'
import Swiper from 'swiper';
import { Pagination, Navigation, EffectCreative } from 'swiper/modules';
import 'swiper/css/effect-creative';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  init() {
    console.log('storia');

    const swiper = new Swiper('.swiperStoria', {
		effect: "creative",
		speed: 600,
		creativeEffect: {
		  prev: {
			shadow: false,
			translate: [0, 0, -400],
			opacity: 0,
		  },
		  next: {
			shadow: false,
			translate: ["100%", 0, 0],
			opacity: 0,
		  },
		},
		modules: [Navigation, EffectCreative],
		slideToClickedSlide: true,
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
		slidesPerView: 1,
		loop: false,
		on: {
		  slideChange: function () {
			updateTimelineDots(this.activeIndex);
		  },
		},
	  });
	  
	  // Funzione per aggiornare i pallini della timeline
	  function updateTimelineDots(activeIndex) {
		const dots = document.querySelectorAll('.timeline-dot'); // Seleziona tutti i pallini
		dots.forEach((dot, index) => {
		  if (index === activeIndex) {
			dot.classList.add('activeDot'); // Aggiungi classe attiva
		  } else {
			dot.classList.remove('activeDot'); // Rimuovi classe attiva
		  }
		});
	  }
	  
	  // Aggiungi gestore di eventi ai pallini
	  document.querySelectorAll('.timeline-dot').forEach(dot => {
		dot.addEventListener('click', function() {
		  const index = parseInt(this.getAttribute('data-index')); // Ottieni l'indice dal data-attribute
		  swiper.slideTo(index); // Vai alla slide corrispondente
		});
	  });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
